var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-user fa-fw fa-male"}),_vm._v(" "+_vm._s(_vm.$label("user.users", "Users"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('user.create_new_user', 'Create new user'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('user.create_new_user', 'Create new user'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewUser' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})])],1)])]),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label("user.user_failed_request", "Request failed while loading user."))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"users-table","loading":_vm.loading,"columns":[
      {
        title: 'Name',
        id: function (row) { return ("user-name-" + (row.id)); },
        sorting: true,
        value: function (row) { return ((row.last_name) + " " + (row.first_name)); }
      },
      {
        title: 'Email',
        id: function (row) { return ("user-email-" + (row.id)); },
        field: 'email'
      },
      {
        title: 'Permissions',
        field: 'permissions'
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'UserDetails',
            params: { user_id: row.id }
          });
        }
      },
      {
        type: 'delete',
        id: function (row) { return ("delete-user-button-" + (row.id)); },
        onClick: function (row) { return _vm.deleteUser(row.id); }
      },
      {
        icon: 'envelope-o',
        iconSize: 'lg',
        bgColor: 'primary',
        onClick: function () {
          _vm.$router.push('/settings/users/id/message/');
        }
      }
    ],"data":_vm.users,"meta":_vm.metaData,"selectable":""},on:{"onRowSelect":function () {},"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getUsers({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewUser' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("user.create_new_user", "Create new user")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }